import * as ACTIONS from 'constant/action/nprinting'
import { handleActions } from 'redux-actions'

const initialState = {
  campaignLoading: {},
  campaignResult: {},
  campaigns: [],
  loading: false,
  requestResponse: null,
  usersRequests: []
}
export default handleActions(
  {
    [ACTIONS.REQUEST_RESPONSE]: (state, action) => ({
      ...state,
      requestResponse: action.payload
    }),
    [ACTIONS.UPDATE_CAMPAIGNS]: (state, action) => ({
      ...state,
      campaigns: action.payload
    }),
    [ACTIONS.SET_LOADING]: (state, action) => ({
      ...state,
      loading: action.payload
    }),
    [ACTIONS.SET_CAMPAIGN_LOADING]: (state, action) => ({
      ...state,
      campaignLoading: action.payload
    }),
    [ACTIONS.UPDATE_CAMPAIGN_RESULT]: (state, action) => ({
      ...state,
      campaignResult: action.payload
    }),
    [ACTIONS.UPDATE_USERS_REQUESTS]: (state, action) => ({
      ...state,
      usersRequests: action.payload
    })
  },
  initialState
)
